import { axiosInstance as request } from '@api/rest.service'

/**
 * @description GET /charts/value-per-department-over-time
 * @returns {AxiosPromise<any>}
 */
export const GET_VALUE_PER_DEPARTMENT_OVER_TIME_CHART = () => request.get('/charts/value-per-department-over-time')

/**
 * @description GET /charts/share-per-department?year={year}
 * @returns {AxiosPromise<any>}
 */
export const GET_SHARE_PER_DEPARTMENT = year => request.get(`/charts/share-per-department?year=${year}`)

/**
 * @description GET /charts/share-per-department/underlying-data?paginated=true
 * @returns {AxiosPromise<any>}
 */
export const GET_PAGINATED_SHARE_PER_DEPARTMENT = (params, year, depName) =>
  request.get(`/charts/share-per-department/underlying-data?paginated=true`, {
    params: {
      ...params,
      year,
      department_name: depName
    }
  })

/**
 * @description GET /charts/budget-vs-actual-per-department-fixed-placement-chart?year={year}
 * @returns {AxiosPromise<any>}
 */
export const GET_FIXED_PLACEMENT_CHART_BUDGET_VS_ACTUAL_PER_DEP = year =>
  request.get(`/charts/budget-vs-actual-per-department-fixed-placement-chart?year=${year}`)

/**
 * @description GET /charts/budget-vs-actual-per-department-combination-chart?year={year}
 * @returns {AxiosPromise<any>}
 */
export const GET_COMBINATION_CHART_BUDGET_VS_ACTUAL_PER_DEP = year =>
  request.get(`/charts/budget-vs-actual-per-department-combination-chart?year=${year}`)
